export default {
    topics: [
        {
            title: ' GetQuarantines ',
            href: 'sm-address-GetQuarantines.html',
            attributes: { 'data-id': 'sm-address-GetQuarantines' },
            menu: { hasChildren: false },
            tocID: 'sm-address-GetQuarantines-d66e2111',
            topics: [],
        },
    ],
};

